import type { StateCreator } from 'zustand/vanilla';
import type { CreationDetailThumbScrollListProps, UpdateCreationInteractionStatusFn } from '@/app/types';

/** 与 FeedDetailConfig 对齐命名：使用 handleVote/handleCollect 等回调，但限定为 creation 场景 */
export type CreationDetailStoreConfig = {
  openInNewTab?: boolean;
  handleVote?: UpdateCreationInteractionStatusFn;
  handleUnVote?: UpdateCreationInteractionStatusFn;
  handleCollect?: UpdateCreationInteractionStatusFn;
  handleUnCollect?: UpdateCreationInteractionStatusFn;
  onClose?: () => void;
  thumbScrollListConfig?: Pick<
    CreationDetailThumbScrollListProps,
    'list' | 'hasMore' | 'onLoadMore' | 'onThumbnailClick'
  >;
};

export interface CreationDetailState {
  creationDetailConfig: CreationDetailStoreConfig | null;
}

export interface CreationDetailStore extends CreationDetailState {
  syncCreationDetailConfig: (config: CreationDetailStoreConfig) => void;
  resetCreationDetailConfig: () => void;
}

const initialState: CreationDetailState = {
  creationDetailConfig: null,
};

export const createCreationDetailSlice: StateCreator<CreationDetailStore, [], [], CreationDetailStore> = (set) => ({
  ...initialState,

  syncCreationDetailConfig: (config) => {
    set((state) => ({
      ...state,
      creationDetailConfig: state.creationDetailConfig ? { ...state.creationDetailConfig, ...config } : { ...config },
    }));
  },

  resetCreationDetailConfig: () => {
    set({ creationDetailConfig: null });
  },
});
